<template>
  <div class="max-w-5xl mx-auto">
    <BaseCard>
      <BaseCardBody>
        <FunnelChart :stages="stages" />
      </BaseCardBody>
    </BaseCard>
  </div>
</template>

<script>
import FunnelChart from '@/components/Funnel/FunnelChart.vue';

export default {
  components: { FunnelChart },
  props: {
    stages: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
